export function debounce(fn: any, delay: any) {
  let timer: any = null //借助闭包
  return function () {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(fn, delay)
  }
}

export function throttle(fn: any, delay: any) {
  let valid = true
  return function () {
    if (!valid) {
      //休息时间 暂不接客
      return false
    }
    // 工作时间，执行函数并且在间隔期内把状态位设为无效
    valid = false
    setTimeout(() => {
      fn()
      valid = true
    }, delay)
  }
}

export const verification = (reg: any) => {
  return (str: string): boolean => {
    if (reg.test(str)) {
      return true
    }
    return false
  }
}

export function swapArray(array: any, index1: number, index2: number) {
  // arr[index1] = arr.splice(index2, 1, arr[index1])[0];
  console.log(index1, index2)
  ;[array[index1], array[index2]] = [array[index2], array[index1]]
  return array
}

export const removeArray = (arr: any, item: number) => {
  if (arr.includes(item)) {
    const index = arr.indexOf(item)
    arr.splice(index, 1)
  }
}

// 文件流转blob对象下载
export function downloadFile(data: any, fileName?: any, type?: any) {
  // 获取heads中的filename文件名
  data = new Blob([data], {
    type: type || 'application/octet-stream;charset=utf-8'
  })
  const urlObject = window.URL || window.webkitURL || window
  // 创建下载的链接
  const downloadElement = document.createElement('a')
  const href = urlObject.createObjectURL(data)
  downloadElement.href = href
  // 下载后文件名
  downloadElement.download = fileName
  document.body.appendChild(downloadElement)
  // 点击下载
  downloadElement.click()
  // 下载完成移除元素
  document.body.removeChild(downloadElement)
  // 释放掉blob对象
  urlObject.revokeObjectURL(href)
}

// 回到顶部
export const scrollTopTo = (data: any) => {
  window.scrollTo({
    top: data.top || 0,
    behavior: data.behavior || 'smooth'
  })
}

export const getOpacityColor = (thisColor: any, thisOpacity: any) => {
  if (!thisColor) {
    return 'transparent'
  }
  let theColor = thisColor.toLowerCase()
  //十六进制颜色值的正则表达式
  let r = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  // 如果是16进制颜色
  if (theColor && r.test(theColor)) {
    if (theColor.length === 4) {
      let sColorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        sColorNew += theColor.slice(i, i + 1).concat(theColor.slice(i, i + 1))
      }
      theColor = sColorNew
    }
    //处理六位的颜色值
    let sColorChange = []
    for (let j = 1; j < 7; j += 2) {
      sColorChange.push(parseInt('0x' + theColor.slice(j, j + 2)))
    }
    return 'rgba(' + sColorChange.join(',') + ',' + thisOpacity + ')'
  }
  // 如果是rgba或者rgb
  if (theColor.startsWith('rgb')) {
    let numbers = theColor.match(/(\d(\.\d+)?)+/g)
    numbers = numbers.slice(0, 3).concat(thisOpacity)
    return 'rgba(' + numbers.join(',') + ')'
  }

  return theColor
}

/**
 * 手机号检测
 * @param phoneNumber
 * @returns
 */
export const checkPhone = (phoneNumber: any) => {
  const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  return reg.test(phoneNumber)
}

/**
 * 邮箱检测
 * @param emailNumber
 * @returns
 */
export const checkEmail = (emailNumber: any) => {
  const reg =
    /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)*(\.[a-zA-Z0-9]{2,9}){1,2}$/
  return reg.test(emailNumber)
}

// 加密手机号
export const encryptionPhone = (phone: any) => {
  let newPhone = ''
  if (phone) newPhone = phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
  return newPhone
}

export const getImgWH = (url: any) => {
  return new Promise((resolve, reject) => {
    let image = new Image()
    let imgSize = {
      width: 0,
      height: 0
    }
    image.onload = () => {
      imgSize = {
        width: image.width,
        height: image.height
      }
      resolve(imgSize)
    }
    image.src = url
  })
}

export const isMobile = () => {
  const mobile = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
  return mobile
}

export const isWeixin = () => {
  const weixin =
    navigator.userAgent.toLowerCase().indexOf('MicroMessenger') > -1
  return weixin
}

export const isSafari = () => {
  const s = navigator.userAgent.toLowerCase().match(/version\/([\d.]+).*safari/)
  const isTrue = s ? s[0] : false
  return isTrue
}

export const formatDate = function (d: any, f?: any) {
  const formatType = f || 'YYYY-MM-DD HH:mm:ss'
  const date = new Date(d)
  const YY = date.getFullYear() + '-'
  const MM =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-'
  const DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  const hh =
    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  const mm =
    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  const ss =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  if (formatType === 'YYYY-MM-DD') {
    return YY + MM + DD
  } else {
    return YY + MM + DD + ' ' + hh + mm + ss
  }
}

export function generateUniqueId() {
  const timestamp = new Date().getTime().toString(36)
  const randomNum = Math.random().toString(36).substr(2, 5)
  const uniqueId = timestamp + randomNum + 'ID'
  return uniqueId
}

export const getQueryParam = (key: string) => {
  const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
  const r = window.location.search.substr(1).match(reg)
  console.log(r)
  if (r != null) {
    return decodeURI(r[2])
  }
  return null
}
